import * as React from "react"
import type { SVGProps } from "react"
const SvgInlineSnippet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 22q-.82 0-1.41-.59A2 2 0 0 1 3 20V6q0-.82.59-1.41A2 2 0 0 1 5 4h4.2q.33-.9 1.09-1.45A3 3 0 0 1 12 2q.94 0 1.71.55A3 3 0 0 1 14.8 4H19q.83 0 1.41.59.6.59.59 1.41v14q0 .83-.59 1.41A2 2 0 0 1 19 22zm0-2h14V6H5zm3-2h5q.42 0 .71-.29A1 1 0 0 0 14 17a1 1 0 0 0-.29-.71A1 1 0 0 0 13 16H8a1 1 0 0 0-.71.29A1 1 0 0 0 7 17q0 .42.29.71.29.3.71.29m0-4h8q.42 0 .71-.29A1 1 0 0 0 17 13a1 1 0 0 0-.29-.71A1 1 0 0 0 16 12H8a1 1 0 0 0-.71.29A1 1 0 0 0 7 13a.97.97 0 0 0 1 1m0-4h8q.42 0 .71-.29A1 1 0 0 0 17 9a1 1 0 0 0-.29-.71A1 1 0 0 0 16 8H8a1 1 0 0 0-.71.29A1 1 0 0 0 7 9a.97.97 0 0 0 1 1m4-4.75a.73.73 0 0 0 .75-.75.73.73 0 0 0-.75-.75.73.73 0 0 0-.75.75.73.73 0 0 0 .75.75" />
  </svg>
)
export default SvgInlineSnippet
